import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { getBoardQueueGroups } from '../requests';
import type { GetBoardQueueGroupsRequestType } from '../types';

export const useGetBoardQueueGroups = ({
  pathParams: { organisationId, boardId },
}: GetBoardQueueGroupsRequestType) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.boardQueueGroups, { organisationId, boardId }],
    queryFn: () =>
      getBoardQueueGroups({ pathParams: { organisationId, boardId } }),
  });
